<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link to="/mypage/account">アカウント情報</router-link></li>
                <li class="breadcrumb-item">退会する</li>
            </ol>
        </nav>
        <div class="container">
            <legend>
                退会する
            </legend>
            <div class="hold">
                「貸し本棚」をご利用いただき、ありがとうございます。
                退会処理を続ける場合、以下の事項にご同意ください。
                <ul>
                    <li>退会すると、書籍や感想など、貸し本棚に投稿したすべての情報が削除されます。</li>
                    <li>削除処理はもとに戻すことができません。</li>
                    <li>もし誤って退会処理を実行した場合は、24時間以内にログインにご利用のメールアドレスからお問い合わせください。</li>
                </ul>
            </div>
            <div class="form-group text-center">
                <router-link to="/mypage/account" class="btn btn-secondary">
                    アカウント情報に戻る
                </router-link>
                <button type="button" class="btn btn-danger" @click="resign()">
                    <i class="fas fa-skull-crossbones"></i>
                    退会する
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.hold {
    margin: 2rem 0;
    padding: 2rem 0;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
}
</style>

<script>
export default {
    data() {
        return {
            reason: "",
        }
    },
    methods: {
        resign() {
            Swal.fire({
                title: "退会",
                text: "退会処理を完了します。よろしいですか？",
                icon: "error",
                showCancelButton: true,
                confirmButtonText: "退会する",
                cancelButtonText: "キャンセル",
                confirmButtonColor: "crimson",
                cancelButtonColor: "gray",
                reverseButtons: true,
            }).then(confirm => {
                if (confirm.isConfirmed) {
                    axios.post("/mypage/user/resign").then(res => {
                        alert.msg(res.data);
                        location.href = "/";
                    }).catch(err => { alert.err(err.response); });
                }
            });
        }
    },
}
</script>